module.exports = "<div class=\"row\">\n  <div class=\"col-xs-5 start-datepicker\" style=\"padding-right: 0\">\n    <bp-datepicker model=\"vm.ngStartModel\"\n                   datepicker-options=\"vm.rangepickerOptions\"></bp-datepicker>\n  </div>\n  <div class=\"col-xs-1 input-padding-left\" style=\"text-align: center;padding-right: 0;max-width: 35px;line-height: 31px;\">\n    -\n  </div>\n  <div class=\"col-xs-5 input-padding-left\">\n    <bp-datepicker model=\"vm.ngEndModel\"\n                   datepicker-options=\"vm.endTimeOptions\"></bp-datepicker>\n  </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/rangepicker/template.html
 ** module id = 171
 ** module chunks = 0
 **/